import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { ShipmentQuery } from '../../../models/shipment-query';
import { ShipmentHeader } from '../../../models/shipment-header';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { Injectable } from '@angular/core';
import { TableQuery } from '../../../interfaces/table-query';
import { Page } from 'src/app/interfaces/page';
import { map } from 'rxjs/operators';

@Injectable()
export class ShipmentHeaderService implements TableQuery<ShipmentHeader, ShipmentQuery> {

    constructor(private http: HttpClient) {}

    query(query: ShipmentQuery): Observable<Page<ShipmentHeader>> {
        let params = new HttpParams()
            .set('page', query.pageNumber.toString())
            .set('itemsPerPage', query.itemsPerPage.toString())
            .set('order[' + query.sortColumn + ']', query.sortDescending ? 'DESC' : 'ASC');
        if (query.state) {
            params = params.set('status', query.state);
        }
        if (query.afterDate) {
            params = params.set('shipmentDate[gte]', query.afterDate);
        }
        if (query.beforeDate) {
            params = params.set('shipmentDate[lt]', query.beforeDate);
        }
        for (const filter of query.shipper) {
            params = params.set('shipper.' + filter.property + '[' + filter.operator + ']', filter.value);
        }
        for (const filter of query.destination) {
            params = params.set('destination.' + filter.property + '[' + filter.operator + ']', filter.value);
        }
        if (query.courier) {
            params = params.set('courier', query.courier);
        }
        if (query.serviceId) {
            params = params.set('serviceId', query.serviceId);
        }
        if (query.batchId) {
            params = params.set('batchId', query.batchId);
        }
        if (query.filter) {
            params = params.set('terms', query.filter);
        }
        const headers = new HttpHeaders({ Accept: 'application/ld+json' });
        return this.http.get<any>(`${environment.apiUrl}/shipments`, { headers, params }).pipe(
            map(result => ({
                totalCount: result['hydra:totalItems'],
                page: result['hydra:member']
            }))
        );
    }

    search(term: string): Observable<ShipmentHeader[]> {
        const params = new HttpParams()
            .set('terms', term)
            .set('itemsPerPage', '20');
        const headers = new HttpHeaders({ Accept: 'application/ld+json' });
        return this.http.get<any>(`${environment.apiUrl}/shipments`, { headers, params }).pipe(
            map(result => result['hydra:member'])
        );
    }
}
